<script setup>
defineProps({
  class: { type: String, default: '' },
})
</script>

<template>
  <section
    class="w-screen max-w-screen-xl xl:mx-auto | px-6 xl:px-8"
    :class="class"
  >
    <slot />
  </section>
</template>
